//用户管理
export default [
  {
    path: '/informationManage',
    component: resolve => require(['../pages/operManage/informationManage.vue'], resolve),
    name: 'informationManage',
    title: "资讯管理",
    meta: {
      title: "资讯管理"
    }
  },
  {
    path: '/bannerManage',
    component: resolve => require(['../pages/operManage/bannerManage.vue'], resolve),
    name: 'bannerManage',
    title: "Banner图管理",
    meta: {
      title: "Banner图管理"
    }
  },
  {
    path: '/firstPage',
    component: resolve => require(['../pages/operManage/firstPage.vue'], resolve),
    name: 'firstPage',
    title: "首页ICON",
    meta: {
      title: "首页ICON"
    }
  },
  {
    path: '/hotelReco',
    component: resolve => require(['../pages/operManage/hotelReco.vue'], resolve),
    name: 'hotelReco',
    title: " 酒店首页推荐管理",
    meta: {
      title: "酒店首页推荐管理"
    }
  },
  {
    path: '/firstReco',
    component: resolve => require(['../pages/operManage/firstReco.vue'], resolve),
    name: 'firstReco',
    title: "首页推荐管理",
    meta: {
      title: "首页推荐管理"
    }
  },
  {
    path: '/choiceManage',
    component: resolve => require(['../pages/operManage/choiceManage.vue'], resolve),
    name: 'choiceManage',
    title: "精选管理",
    meta: {
      title: "精选管理"
    }
  },
  {
    path: '/homeMould',
    component: resolve => require(['../pages/operManage/homeMould.vue'], resolve),
    name: 'homeMould',
    title: "版块管理",
    meta: {
      title: "版块管理"
    }
  },
  {
    path: '/hotCouponManage',
    component: resolve => require(['../pages/operManage/hotCouponManage.vue'], resolve),
    name: 'hotCouponManage',
    title: "热销卡券",
    meta: {
      title: "热销卡券"
    }
  },
  {
    path: '/presentBooksManage',
    component: resolve => require(['../pages/operManage/presentBook.vue'], resolve),
    name: 'presentBooksManage',
    title: "公益图书",
    meta: {
      title: "公益图书"
    }
  },
  {
    path: '/articleStatistics',
    component: resolve => require(['../pages/operManage/articleStatistics.vue'], resolve),
    name: 'articleStatistics',
    title: "文章统计分析",
    meta: {
      title: "文章统计分析"
    }
  }
];
